import { getApiHeaders } from "@/utils/Request";

/**
 * 发送聊天消息
 * @param msg 用户输入的消息内容
 * @param session_id 会话ID
 * @param use_history 是否使用历史记录
 * @param onChunk 接收流式响应的回调函数
 * @param signal 可选的 AbortSignal 用于取消请求
 * @param files 可选的文件URL数组
 * @param deepthink 可选的深度思考模式，0表示关闭，1表示开启
 * @param start_chat_id 可选的起始聊天ID
 * @param agent_id 可选的智能体ID
 * @returns Promise<void>
 */
export const sendChatMessage = async (
  msg: string,
  session_id: string,
  use_history: number,
  onChunk: (chunk: string) => void,
  signal?: AbortSignal,
  files: string[] = [],
  deepthink?: number,
  start_chat_id?: number,
  start_chat_text?: string,
  agent_id?: string,
): Promise<void> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_BASE_URL}/api/chat/sendmsg`,
      {
        method: "POST",
        headers: getApiHeaders(),
        body: JSON.stringify({
          msg,
          session_id,
          use_history,
          files,
          ...(deepthink !== undefined && { deepthink }),
          ...(start_chat_id !== undefined && { start_chat_id }),
          ...(start_chat_text && { start_chat_text }),
          ...(agent_id && { agent_id }),
        }),
        cache: "no-cache",
        signal,
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // 获取响应体的Reader
    const reader = response.body?.getReader();
    if (!reader) {
      throw new Error("无法获取响应流");
    }
    const decoder = new TextDecoder("utf-8");
    let done = false;

    // 循环读取流数据
    while (!done) {
      const { value, done: readerDone } = await reader.read();
      done = readerDone;

      if (value) {
        // 解码数据并传递给回调函数
        const chunk = decoder.decode(value, { stream: true });
        onChunk(chunk);
      }
    }
  } catch (error: any) {
    if (error.name === "AbortError") {
      return;
    }
    console.error("发送聊天消息失败:", error);
    throw new Error(error.message || "发送消息失败，请稍后重试");
  }
};
